/*
const myPath = new SidesTextPath({
  x: 50,
  y: 50,
  fill: 'black',
  fontSize: 24,
  fontFamily: 'Arial',
  text: 'Initial Text Initial Text Initial Text Initial Text Initial Text Initial Text ',
  radius: 200,
  sides: 6,
});
//console.log("myPath", myPath);
layer.add(myPath);
layer.draw();
*/
class SidedTextPath extends BaseTextPath {
  constructor(config) {
    super(config);

    this.className = 'SidedTextPath';

    this.radius(config?.radius ?? 200);
    this.sides(config?.sides ?? 6);
  }


  static getAttrNames() { return ['radius', 'sides', 'waves']; }
  static getDefaultAttrs() { return { radius: 200, sides: 6 }; }


  radius(v) {
    if (v === undefined) return this.attrs.radius ?? 0;
    this.attrs.radius = v;
    this.updatePath();
    return this;
  }


  sides(v) {
    if (v === undefined) return this.attrs.sides ?? 0;
    this.attrs.sides = v;
    this.updatePath();
    return this;
  }


  updatePath () {
    this.setData(this.generateSvgPath(this.sides(), this.radius(), 200, 200 ));
  }
  

  /**
   * Generates the 'd' attribute string for a regular polygon SVG path.
   * @param {number} sides - The number of sides.
   * @param {number} radius - The distance from the center to a vertex.
   * @param {number} centerX - The x-coordinate of the center.
   * @param {number} centerY - The y-coordinate of the center.
   * @returns {string} The SVG path data string.
   */
  generateSvgPath(sides, radius, centerX, centerY) {
    let path = "";
    const angleIncrement = (Math.PI * 2) / sides;

    for (let i = 0; i < sides+1; i++) {
      const angle = angleIncrement * i - Math.PI / 2; // Subtract Math.PI/2 to start at the top
      const x = centerX + radius * Math.cos(angle);
      const y = centerY + radius * Math.sin(angle);

      if (i === 0) {
        path += `M${x},${y}`; // Move to the first point
      } else {
        path += `L${x},${y}`; // Draw a line to subsequent points
      }
    }

    path += "Z"; // Close the path
    return path;
  }

}
